(function(window, document) {
  'use strict';

  var EXPERIMENT_ID = 'repair_advisor_v1';
  var api;
  var loading = false;
  var loaded = false;
  var pendingAssignment = null;
  var shown = false;
  var revalidationInFlight = false;

  function exactColorHubPath() {
    return /^\/colors\/[^/]+\/[^/]+\/?$/.test(String(window.location && window.location.pathname || ''));
  }

  function repairAdvisorPath() {
    return /^\/colors\/[^/]+\/[^/]+\/?$/.test(String(window.location && window.location.pathname || '')) || /^\/colors\/[^/]+\/[^/]+\/(?:pen|bottle|spray|pro|kit-pen|kit-bottle|kit-spray)\/?$/.test(String(window.location && window.location.pathname || ''));
  }

  function approvedPublicReviewPath() {
    var path = String(window.location && window.location.pathname || '').toLowerCase().replace(/\/+$/, '');
    return String(window.location && window.location.hostname || '').toLowerCase() === 'www.paintscratch.com' && (path === '/colors/bmw/iberian-red-016' || path === '/colors/bmw/dravite-grey-tricoat-c36');
  }

  function developmentReviewRequested() {
    return /^(?:compat-dev|dev|staging)\.paintscratch\.com$/.test(String(window.location && window.location.hostname || '').toLowerCase()) && /(?:^|[?&])ps_ab_repair_advisor=B(?:&|$)/i.test(String(window.location && window.location.search || '')) && repairAdvisorPath();
  }

  function photoOptInRequested() {
    var root = firstRoot();
    var panel = root && typeof root.querySelector === 'function' ? root.querySelector('[data-ps-repair-photo]') : null;
    return exactColorHubPath() && /(?:^|[?&])ps_repair_photo=1(?:&|$)/.test(String(window.location && window.location.search || '')) && panel && !panel.hidden;
  }

  function repairStartRequested() {
    var root = firstRoot(), pending, path = String(window.location && window.location.pathname || '').toLowerCase().replace(/\/+$/, ''), host = String(window.location && window.location.hostname || '').toLowerCase();
    if (!/^(?:www|dev|compat-dev|test)\.paintscratch\.com$/.test(host)) return false;
    if (!root || !root.getAttribute || root.getAttribute('data-ps-repair-start-enabled') === null) return false;
    if (root.getAttribute('data-ps-repair-start') !== null) return path === '/pages/what-to-order';
    if (!repairAdvisorPath()) return false;
    try { pending = JSON.parse(window.sessionStorage.getItem('ps_repair_start_pending_v1') || '{}'); } catch (_e) { return false; }
    return pending && pending.source === 'what-to-order' && typeof pending.time === 'number' && pending.time > Date.now() - 600000 && pending.time <= Date.now();
  }

  function publicReviewRequested() {
    return approvedPublicReviewPath() && /(?:^|[?&])ps_repair_advisor_review=B(?:&|$)/i.test(String(window.location && window.location.search || ''));
  }

  function firstRoot() {
    return document.querySelector('[data-ps-repair-experiment]');
  }

  function photoAnalyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
    try { return privacy.analyticsProcessingAllowed() === true; } catch (_e) { return false; }
  }

  function loadStyle(url, callback) {
    var link;
    if (!url) { callback(false); return; }
    link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.setAttribute('data-ps-repair-advisor-asset', 'style');
    link.onload = function() { callback(true); };
    link.onerror = function() { callback(false); };
    document.head.appendChild(link);
  }

  function loadScript(url, name, callback) {
    var script;
    if (!url) { callback(false); return; }
    script = document.createElement('script');
    script.src = url;
    script.setAttribute('data-ps-repair-advisor-asset', name);
    script.onload = function() { callback(true); };
    script.onerror = function() { callback(false); };
    document.head.appendChild(script);
  }

  function context(assignment, root) {
    return {
      experiment_id: EXPERIMENT_ID,
      variant: assignment && assignment.variant || '',
      phase_id: assignment && assignment.phase_id || '',
      surface: root && root.getAttribute('data-ps-guide-surface') || ''
    };
  }

  function experimentContainer(root) {
    var container = root && root.parentNode;
    while (container && container !== document.body) {
      if (container.getAttribute && container.getAttribute('data-ps-repair-experiment-container') !== null) return container;
      container = container.parentNode;
    }
    return null;
  }

  function hide() {
    var root = firstRoot();
    var container = experimentContainer(root);
    pendingAssignment = null;
    shown = false;
    if (root) root.hidden = true;
    if (container) container.hidden = true;
  }

  function show(assignment, root) {
    var container = experimentContainer(root);
    if (!root || !assignment || assignment.variant !== 'B' || shown) return;
    shown = true;
    root.hidden = false;
    if (container) container.hidden = false;
    if (assignment.forced) {
      if (assignment.photo_opt_in && photoAnalyticsAllowed()) {
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'repair_photo_opt_in_ready', repair_photo_opt_in: true }); } catch (_e) {}
      }
      if (assignment.guide_opt_in && photoAnalyticsAllowed()) {
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'repair_guide_opt_in_ready', repair_guide_opt_in: true }); } catch (_e2) {}
      }
      return;
    }
    if (api && typeof api.recordExposure === 'function') api.recordExposure();
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'repair_advisor_experiment_ready', repair_advisor_experiment_id: EXPERIMENT_ID, repair_advisor_variant: assignment.variant, repair_advisor_phase_id: assignment.phase_id || '', repair_advisor_surface: root.getAttribute('data-ps-guide-surface') || '' });
    } catch (_e) {}
  }

  function validateTreatment(assignment, root) {
    if (!assignment || assignment.variant !== 'B' || !root) { hide(); return; }
    if (!api || typeof api.revalidateCurrentAssignment !== 'function') { hide(); return; }
    if (revalidationInFlight) return;
    revalidationInFlight = true;
    api.revalidateCurrentAssignment(function(valid) {
      revalidationInFlight = false;
      if (!valid) { hide(); return; }
      show(assignment, root);
    });
  }

  function reveal(assignment) {
    var root = firstRoot();
    if (!root) return;
    if (loaded) { validateTreatment(assignment, root); return; }
    pendingAssignment = assignment;
    if (loading) return;
    loading = true;
    loadStyle(root.getAttribute('data-ps-repair-css'), function(styleOk) {
      if (!styleOk) { loading = false; return; }
      loadScript(root.getAttribute('data-ps-repair-shop-js'), 'shop', function(shopOk) {
        if (!shopOk) { loading = false; return; }
        loadScript(root.getAttribute('data-ps-repair-guide-js'), 'guide', function(guideOk) {
          var photo = typeof root.querySelector === 'function' ? root.querySelector('[data-ps-repair-photo]') : null;
          function finishGuideLoad() {
            loadScript(root.getAttribute('data-ps-repair-start-agent-js'), 'repair-start-agent', function() { completeGuideLoad(); });
          }
          function completeGuideLoad() {
            loaded = true;
            loading = false;
            if (pendingAssignment) validateTreatment(pendingAssignment, root);
            pendingAssignment = null;
          }
          if (!guideOk) { loading = false; return; }
          if (photo && !photo.hidden) loadScript(root.getAttribute('data-ps-repair-photo-js'), 'photo', finishGuideLoad);
          else finishGuideLoad();
        });
      });
    });
  }

  function handleAssignment(assignment) {
    if (!assignment || assignment.variant !== 'B') { hide(); return; }
    reveal(assignment);
  }

  // A deliberate damage-first visit reuses the guide without enrolling in its experiment.
  if (repairStartRequested()) {
    window.PS = window.PS || {};
    window.PS.repairGuideOptIn = true;
    window.PS.repairPhotoAnalyticsAllowed = photoAnalyticsAllowed;
    api = { revalidateCurrentAssignment: function(callback) { callback(true); } };
    reveal({ variant: 'B', forced: true, guide_opt_in: true });
    return;
  }

  // A deliberate photo link reuses the guide without enrolling in its experiment.
  if (photoOptInRequested()) {
    window.PS = window.PS || {};
    window.PS.repairPhotoOptIn = true;
    window.PS.repairPhotoAnalyticsAllowed = photoAnalyticsAllowed;
    var closePhoto = firstRoot().querySelector('[data-ps-repair-photo-close]');
    if (closePhoto) { closePhoto.href = window.location.pathname; closePhoto.hidden = false; }
    api = { revalidateCurrentAssignment: function(callback) { callback(true); } };
    reveal({ variant: 'B', forced: true, photo_opt_in: true });
    return;
  }

  // Explicit reviews never enroll visitors, use managed assignments, or record measurement.
  if (developmentReviewRequested() || publicReviewRequested()) {
    window.PS = window.PS || {};
    window.PS.repairAdvisorPreview = true;
    if (publicReviewRequested()) window.PS.repairAdvisorPublicReview = true;
    api = {
      revalidateCurrentAssignment: function(callback) { callback(true); }
    };
    reveal({ variant: 'B', forced: true, test_assignment: true, phase_id: 'phase_qa' });
    return;
  }

  if (!window.PS || !window.PS.Experiments || typeof window.PS.Experiments.registerRuntimeExperiment !== 'function') return;
  api = window.PS.Experiments.registerRuntimeExperiment({
    id: 'repair_advisor_v1',
    storageKey: 'ps_ab_repair_advisor_assignment_v2',
    cookieKey: 'ps_ab_repair_advisor_assignment_v2',
    cartPrefix: 'ps_ab_repair_advisor',
    forceParam: 'ps_ab_repair_advisor',
    requiresAnalyticsConsent: true,
    shouldAutoRecordExposure: function(assignment) { return assignment && assignment.variant === 'A'; },
    isEligible: repairAdvisorPath,
    canAssign: exactColorHubPath
  });
  if (!api) return;
  window.PS.Experiments.getRepairAdvisor = api.getAssignment;
  window.PS.Experiments.getRepairAdvisorContext = function() { return context(api.getAssignment(), firstRoot()); };
  api.onReady(handleAssignment);
  handleAssignment(api.getAssignment());
  if (window.setInterval) {
    window.setInterval(function() {
      var root = firstRoot();
      if (shown && root && !root.hidden) validateTreatment(api.getAssignment(), root);
    }, 30000);
  }
})(window, document);
